// Mirrors the chatbot's message tokenizer (Plist-Open-AI-Chatbot-Front-End:
// src/utility/messageFormat.cjs) so previews render text — line breaks,
// **bold**, _italic_, ~underline~, ###heading### — exactly like the live widget.
export const tokenizeMessage = (value) => {
  const text = String(value ?? "");
  const tokens = [];
  const pattern = /(###(.*?)###|\*\*(.*?)\*\*|_(.*?)_|~(.*?)~|\n)/g;
  let cursor = 0;
  let match;

  while ((match = pattern.exec(text)) !== null) {
    if (match.index > cursor) tokens.push({ type: "text", value: text.slice(cursor, match.index) });
    if (match[0] === "\n") tokens.push({ type: "lineBreak", value: "" });
    else if (match[2] !== undefined) tokens.push({ type: "heading", value: match[2] });
    else if (match[3] !== undefined) tokens.push({ type: "bold", value: match[3] });
    else if (match[4] !== undefined) tokens.push({ type: "italic", value: match[4] });
    else if (match[5] !== undefined) tokens.push({ type: "underline", value: match[5] });
    cursor = pattern.lastIndex;
  }

  if (cursor < text.length) tokens.push({ type: "text", value: text.slice(cursor) });
  return tokens;
};
